import React, {useState, useEffect, useLayoutEffect, useRef, useCallback } from "react";
import SearchBar from './SearchBar.jsx';
import Map from './Map.jsx';
import ResultsList from './ResultsList.jsx';
import OpenResults from './OpenResults.jsx';
import { useSpring, animated } from '@react-spring/web'
import { useDrag } from '@use-gesture/react'

const ResultsContainer = ({}) => {

  const resultsContainer = useRef(null);
  const searchBarRef = useRef(null);
  const utilityBarRef = useRef(null);
  const [mapOpen, setMapOpen] = useState(window.innerWidth < 1000);
  const [mapVisible, setMapVisible] = useState(window.innerWidth < 1000);
  const [{ width, height }, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })
  const bottomOffset = useRef(0);
  const isMapClosed = useRef(true); // this feels unnecessary but I'm not sure how else to cancel the mapVisible set state in the slideResultsUp callback

  const [{ y }, api] = useSpring(() => ({ y: 0 }))

  const [{scroll}, scrollApi] = useSpring(() => ({
    immediate: false,
    scroll: window.scrollY,
    onChange: props => {
      window.scroll(0, props.value.scroll);
    },
  }));

  useLayoutEffect(() => {
    scrollApi.start({scroll:0});
    const resize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  useEffect(() => {
    if(mapOpen) {
      scrollApi.set({scroll: window.scrollY})
      scrollApi.start({scroll:0});
      isMapClosed.current = false;
      slideResultsDown();
    } else {
      isMapClosed.current = true;
      slideResultsUp();
    }
  }, [mapOpen, width, height])

  const slideResultsDown = useCallback(() => {
    setMapVisible(true);
    document.documentElement.classList.add("lock");

    const utilityBarHeight = utilityBarRef.current ? utilityBarRef.current.getBoundingClientRect().height : 0;
    const utilityBarOffset = searchBarRef.current ? window.scrollY + searchBarRef.current.getBoundingClientRect().bottom : 0;
    const windowHeight = window.innerHeight;
    bottomOffset.current = windowHeight - utilityBarOffset - utilityBarHeight - 50;

    api.start({ y: bottomOffset.current })
  }, [])

  const slideResultsUp = useCallback(async () => {
    document.documentElement.classList.remove("lock");
    await api.start({ y: 0 })[0];
    if(isMapClosed.current){
      setMapVisible(false);
    }
  }, [])

  const handleHandleClick = () => {
    setMapOpen(false);
  }

  const bind = useDrag(({ down, movement: [mx, my], velocity: [vx, vy] }) => {
    if(!mapOpen) return;
    if(down){
      api.start({ y: my + bottomOffset.current })
    } else if (my * -2 > bottomOffset.current || vy > 1){
      setMapOpen(false);
    } else {
      api.start({ y: bottomOffset.current })
    }
  })

  const bindProps = mapVisible ? {
    ...bind()
  } : {}

  const mobile = width < 1000;

  return (
    <div className={`ft_dealer-locator__results-container ${mapOpen || !mobile ? 'map-open' : ''}`}>
      <div className="ft_dealer-locator__results-lower-container ft_dealer-locator__container">
        {mobile ? <SearchBar ref={searchBarRef}/> : null}
        {mapVisible || !mobile ? <Map /> : null}
        <animated.div style={{ y, touchAction: mapVisible ? 'none' : "auto" }} {...bindProps} className="results_sidebar" ref={resultsContainer}>
          {!mobile ? <SearchBar ref={searchBarRef}/> : null}
          <button className="button--handle lg:hidden" onClick={handleHandleClick}>Close Map</button>
          <ResultsList openMap={() => setMapOpen(!mapOpen)} utilityBarRef={utilityBarRef} />
        </animated.div>
        {mobile && <OpenResults bottomOffset={bottomOffset} />}
      </div>
    </div>
  );

}

export default ResultsContainer;
